export default {
  en: {
    label: {
      username: 'Username/Email/Phone',
      password: 'Password',
      remember: 'Remember password',
      otp_title: 'Authenticator Code',
      your_email: 'Your email',
      back_to_login: 'Back to login',
    },
    placeholder: {
      username: 'Username or Email',
      password: 'Password'
    },
    button: {
      login: 'Login',
      register: 'Register',
      forgotpw: 'Forgot password?',
      verify: 'Confirm',
      resend_activation: 'Resend the activation email',
      back_to_login: 'Back to login',
    },
    message: {
      activation_successful: 'Account activation successful. Please log in again to use.',
      activation_success: 'Account activation successful.',
      user_activating: 'Activating your account. Please wait a moment...',
      request_resend_active: 'Resend activation email successfully! Please check your inbox!',
      account_notactivated: 'Your account has not been activated. Please open your email and click on the activation link. If you do not receive the email, please click the button below to resend the activation email.',
      request_activation_success: 'Resend activation email successfully! Please check your inbox!',
    }
  },
  vi: {
    label: {
      username: 'Tên đăng nhập/Email/SĐT',
      password: 'Mật khẩu',
      remember: 'Lưu đăng nhập',
      otp_title: 'Mã xác thực OTP',
      your_email: 'Email của quý khách',
      back_to_login: 'Quay lại đăng nhập',
    },
    placeholder: {
      username: 'Tên đăng nhập/Email',
      password: 'Mật khẩu'
    },
    button: {
      login: 'Đăng nhập',
      register: 'Đăng ký',
      forgotpw: 'Lấy lại mật khẩu',
      verify: 'Xác Nhận',
      resend_activation: 'Gửi lại email kích hoạt',
      back_to_login: 'Quay lại đăng nhập',
    },
    message: {
      activation_successful: 'Kích hoạt tài khoản thành công. Quý khách hãy tiến hành đăng nhập lại để sử dụng.',
      activation_success: 'Kích hoạt tài khoản thành công.',
      user_activating: 'Đang kích hoạt tài khoản của bạn. Vui lòng chờ trong giây lát...',
      request_resend_active: 'Gửi lại email kích hoạt thành công! Vui lòng kiểm tra hộp thư đến của bạn!',
      account_notactivated: 'Tài khoản của bạn chưa được kích hoạt. Hãy mở email của bạn và nhấn vào liên kết kích hoạt tài khoản. Nếu bạn không nhận được email, hãy nhấn vào nút bên dưới để gửi lại email kích hoạt.',
      request_activation_success: 'Gửi lại email kích hoạt thành công! Vui lòng kiểm tra hộp thư đến của bạn!',
    }
  },
  zh: {
    label: {
      username: '名称/邮箱/电话号码',
      password: '密码',
      remember: '记住密码'
    },
    placeholder: {
      username: '名称/邮箱',
      password: '密码'
    },
    button: {
      login: '登录',
      register: '注册',
      forgotpw: '忘记密码'
    }
  }
}
